<template>
    <div class="c-a-radio" :class="{'c-a-radio--invalid': invalid}">
        <p class="c-a-radio__title">{{label}}<span v-if="required"> *</span></p>
        <div class="c-a-radio__inner">
            <label class="c-a-radio__label" :for="`yes_${id}`">
                <input class="c-a-radio__input" type="radio" :name="`radio_${id}`" :id="`yes_${id}`" value="1" checked v-model="selected" v-on:change="updated">
                <span class="c-a-radio__checkmark"></span>
                Ja
            </label>
            <label class="c-a-radio__label" :for="`no_${id}`">
                <input class="c-a-radio__input" type="radio" :name="`radio_${id}`" :id="`no_${id}`" value="0" v-model="selected" v-on:change="updated">
                <span class="c-a-radio__checkmark"></span>
                Nej
            </label>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            id: Number,
            label: String,
            invalid: Boolean,
            required: Boolean,
            question: String,
            dataKey: String,
        },
        data() {
            return{
                selected:'',
            }
        },
        methods:{
            updated(){
                const data = {
                    questionId: this.id,
                    label: this.label,
                    answers: this.selected,
                    radio: true
                };

                if(this.dataKey){
                    data.dataKey = this.dataKey;
                }

                this.$emit('updateData', data);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/request-form/AtomRadioRequestForm.vue